const COMMUNITY_WIKI_ROUTER_PREFIX = 'CommunityWiki-';
const COMMUNITY_EVENT_ROUTER_PREFIX = 'CommunityEvent-';

export {COMMUNITY_WIKI_ROUTER_PREFIX, COMMUNITY_EVENT_ROUTER_PREFIX}
